// extracted by mini-css-extract-plugin
module.exports = {"limiter":"_base-dropdown_limiter_1JW8P"};